import connection from '@/api/connection'

export const singIn = async ({ commit }, user) => {
    try {
        const { username, password } = user
        const { data } = await connection.post('/auth/login', { username, password})
        const { model, success } = data
        const token = model.token
        delete model.token
        
        commit('login', { model, token }  )

        return { success, errors: [], model  }

    } catch (error) {
        const { response } = error
        return { success: false, errors: response.data.errors, model: null  }
    }
}

export const checkAuthentication = async ({ commit }) => {
    const token = localStorage.getItem('token')

    if (!token) {
        commit('logout')
        return { success: false, errors: [{msg: 'token invalido'}] }
    }

    try {
        const { data } = await connection.post('/auth/lookup', { token })
        const { model, success } = data

        commit('login', { model, token } )

        return { success, errors: [], model }

    } catch (error) {
        console.log('error');
        console.log(error);
        commit('logout')
        const { response } = error
        return { success: false, errors: response.data.errors, model: null }
    }
}